module.exports = {
	"accounts": {
		"bank": {
			"save": "Sauvegarder",
			"details": "Détail du possesseur du compte",
			"bank": "Informations bancaire",
			"kyc": "Vérification d'identité",
			"labels": {
				"first_name": "Prénom",
				"last_name": "Nom",
				"AddressLine1": "Rue",
				"PostalCode": "Code postal",
				"City": "Ville",
				"Region": "Région",
				"Country": "Pays",
				"iban": "IBAN",
				"bic": "BIC",
				"kyc": "Pièce d'identité ou passeport"
			},
			"kycStatus": {
				"CREATED": "En cours de validation",
				"REFUSED": "Refusé: {refused_reason_message}",
				"VALIDATED": "Validé",
				"VALIDATION_ASKED": "En cours de validation"
			}
		},
		"informations": {
			"save": "Sauvegarder",
			"address": "Mon adresse",
			"addressText": "Ces informations sont nécessaires pour la vérification de votre compte et pour la facturation",
			"additional": "Informations complémentaires",
			"additionalText": "Ces informations sont nécessaires pour valider votre compte",
			"labels": {
				"email": "Email",
				"first_name": "Prénom",
				"last_name": "Nom",
				"birthday": "Date de naissance",
				"phone": "Numéro de téléphone",
				"AddressLine1": "Rue",
				"PostalCode": "Code postal",
				"City": "Ville",
				"Region": "Région",
				"Country": "Pays",
				"nationality": "Nationalité",
				"country_of_residence": "Pays de résidence",
				"occupation": "Profession",
				"income_range": "Revenus",
				"password": "Nouveau mot de passe"
			}
		},
		"profile": {
			"save": "Sauvegarder",
			"valid": "Valider",
			"offer": "Offre en avant",
			"private": "[Privé]",
			"labels": {
				"cover": "Photo de couverture",
				"avatar": "Photo de profile",
				"jobTitle": "Métier",
				"nickname": "Nom affiché pour vos clients",
				"description": "Description",
				"keywords": "Mots-clefs relatifs à votre activité séparés par une virgule",
				"video": "Ajoutez une vidéo",
				"languages": "Mes langues parlées",
				"resume": "Résumé de votre profile",
				"offerId": "Offre en avant",
				"offerTitle": "Titre du bouton d'action",
				"offerSwitch": "Offre interne",
				"offerLink": "Lien de l'offre"
			}
		},
		"schedule": {
			"title": "Mes horaires de disponibilité téléphonique",
			"addTitle": "Ajouter un créneau",
			"add": "Ajouter un nouveau créneau",
			"addThis": "Ajouter ce créneau",
			"save": "Sauvegarder",
			"header": {
				"day": "Jour",
				"from": "De",
				"to": "À"
			},
			"labels": {
				"timezone": "Fuseau horaire"
			}
		}
	},
	"availabilities": {
		"exepertsperday": {
			"header": {
				"expert": "Expert"
			}
		},
		"expertsperweek": {
			"notAvailable": "Indisponible",
			"available": "Disponibilité maximum ({maxHour}h/24)",
			"header": {
				"expert": "Expert",
				"day": [
					"Dimanche",
					"Lundi",
					"Mardi",
					"Mercredi",
					"Jeudi",
					"Vendredi",
					"Samedi"
				],
				"total": "Total"
			}
		}
	},
	"charts": {
		"averageTime": {
			"label": "Moyenne de temps passé"
		},
		"gains": {
			"label": "Gains"
		},
		"newvsreturning": {
			"title": "Répartition des types d'offres",
			"returning": "Visiteurs récurrents",
			"new": "Nouveaux visiteurs"
		},
		"offerrevenue": {
			"label": "Revenus par offres",
			"mail": "Mail",
			"service": "Service",
			"prepaid_minute": "Forfait",
			"product": "Produit"
		},
		"offertyperevenue": {
			"title": "Répartition des types d'offres",
			"mail": "Mail",
			"service": "Service",
			"prepaid_minute": "Forfait",
			"product": "Produit",
			"availability": "Chat"
		},
		"purchases": {
			"label": "Revenus"
		},
		"sessions": {
			"label": "Nombre de visites"
		}
	},
	"dashboard": {
		"averagetimespent": {
			"title": "Temps moyen passé",
			"notActivated": "Vos statistiques ne sont pas encore activées"
		},
		"gains": {
			"title": "Sur le dernier mois"
		},
		"gainssum": {
			"title": "Total"
		},
		"newvsreturning": {
			"title": "Répartition",
			"notActivated": "Vos statistiques ne sont pas encore activées"
		},
		"offerrepartition": {
			"title": "Par offres"
		},
		"offertyperepartition": {
			"title": "Par type d'offre"
		},
		"purchases": {
			"title": "Sur le dernier mois"
		},
		"purchasessum": {
			"title": "Total"
		},
		"sessions": {
			"title": "Visites sur le dernier mois",
			"notActivated": "Vos statistiques ne sont pas encore activées"
		}
	},
	"expert": {
		"header": {
			"more": "Actions",
			"delete": "Supprimer cet expert",
			"connect": "Se connecter sur son compte",
			"confirmation": "Êtes vous sûr de vouloir supprimer cet expert ?",
			"profile": "Voir le profile"
		},
		"profile": {
			"none": "-",
			"subtitles": {
				"personal": "Informations personnelles",
				"contact": "Information de contact"
			},
			"item": {
				"nickname": "Pseudo",
				"firstName": "Prénom",
				"lastName": "Nom",
				"email": "Email",
				"phone": "Téléphone",
				"createdAt": "Rejoins le"
			}
		},
		"purchases": {
			"title": "Prestations terminées"
		},
		"schedule": {
			"title": "Horaires",
			"timezone": "Fuseau horaire",
			"header": {
				"day": "Jour",
				"from": "de",
				"to": "à"
			},
			"days": [
				"Dimanche",
				"Lundi",
				"Mardi",
				"Mercredi",
				"Jeudi",
				"Vendredi",
				"Samedi"
			]
		}
	},
	"formatters": {
		"errorcode": {
			"code": {
				"101001": "L'utilisateur ne termine pas la transaction",
				"101002": "La transaction a été annulée par l'utilisateur",
				"101101": "Transaction refusée par la banque (Ne pas honorer)",
				"101102": "Transaction refusée par la banque (Montant limite)",
				"101103": "Transaction refusée par le terminal",
				"101104": "Transaction refusée par la banque (limite de carte atteinte)",
				"101105": "La carte a expiré",
				"101106": "La carte est inactive",
				"101111": "Nombre maximum de tentatives atteintes",
				"101112": "Montant maximal dépassé",
				"101113": "Utilisations maximales dépassées",
				"101115": "Dépassement de la limite de débit",
				"101116": "Limite de quantité",
				"101199": "Transaction refusée",
				"101301": "Mode sécurisé: l'authentification 3DSecure a échoué",
				"101302": "Mode sécurisé: la carte n'est pas associée à 3DSecure",
				"101303": "Mode sécurisé: la carte n'est pas compatible avec 3DSecure",
				"101304": "Mode sécurisé: la session d'authentification 3DSecure a expiré",
				"101399": "Mode sécurisé: l'authentification 3DSecure n'est pas disponible",
				"101410": "La carte n'est pas active",
				"105101": "numéro de carte invalide",
				"105102": "Nom du titulaire de carte non valide",
				"105103": "Code PIN non valide",
				"105104": "Format de NIP incorrect",
				"105202": "Numéro de carte: format non valide",
				"105203": "Date d'expiration: format manquant ou non valide",
				"105204": "CVV: format manquant ou non valide",
				"105205": "URL de rappel: format non valide",
				"105206": "Données d'enregistrement: format non valide",
				"105299": "Erreur d'entrée de jeton",
				"001001": "Solde de portefeuille insuffisant",
				"001002": "L'auteur n'est pas le propriétaire du portefeuille",
				"001011": "Le montant de la transaction est supérieur au montant maximal autorisé",
				"001012": "Le montant de la transaction est inférieur au montant minimum autorisé",
				"001013": "Montant de transaction non valide",
				"001014": "CréditedFunds doit être plus de 0 (DebitedFunds ne peut pas égaler les frais)",
				"001030": "L'utilisateur n'a pas été redirigé",
				"001031": "L'utilisateur a annulé le paiement",
				"001032": "L'utilisateur remplit les détails de la carte de paiement",
				"001033": "L'utilisateur n'a pas été redirigé puis la session de paiement a expiré",
				"001034": "L'utilisateur a laissé la session de paiement expirer sans payer",
				"001401": "La transaction a déjà été remboursée avec succès",
				"001599": "Erreur de traitement de jeton",
				"01902": "Cette carte n'est pas active",
				"001999": "Erreur de fonctionnement générique",
				"02101": "Erreur interne",
				"02624": "Carte expirée",
				"02625": "numéro de carte invalide",
				"02626": "Date invalide. Utiliser le format mmdd",
				"02627": "Numéro CCV non valide",
				"02628": "Transaction refusée",
				"02631": "Délai dépassé",
				"02632": "Méthode GET n'est pas autorisée",
				"002998": "Bloqué en raison des limitations de KYC du titulaire du compte bancaire (montant maximum débité ou crédité atteint)",
				"002999": "Bloqué en raison des limitations de KYC d'un Débiteur (montant maximum débité ou crédité atteint)",
				"005403": "Le remboursement ne peut excéder le montant initial de la transaction",
				"005404": "Les frais remboursés ne peuvent dépasser le montant initial des frais",
				"005405": "Solde du portefeuille de frais du client insuffisant",
				"005407": "Duplicated operation: vous ne pouvez pas rembourser le même montant plus d'une fois pour une transaction le même jour",
				"008001": "Carte de contrefaçon",
				"008002": "Carte perdue",
				"008003": "Carte volée",
				"008004": "Bac à cartes non autorisé",
				"008005": "Violation de la sécurité",
				"008006": "Fraude soupçonnée par la banque",
				"008007": "Opposition sur compte bancaire (Temporaire)",
				"008500": "Transaction bloquée par la politique de fraude",
				"008600": "Wallet bloqué par la politique de fraude",
				"008700": "Utilisateur bloqué par la politique de fraude",
				"008999": "Erreur politique de fraude",
				"09101": "Nom d'utilisateur / mot de passe incorrect",
				"009101": "PSP timeout s'il vous plaît essayer tardr",
				"09102": "Le compte est verrouillé ou inactif",
				"009103": "Erreur de configuration PSP",
				"09104": "Le certificat client est désactivé",
				"009199": "Erreur technique de PSP",
				"09201": "Vous ne disposez pas des autorisations pour effectuer cette appel API",
				"009499": "Erreur technique de la banque",
				"009999": "Erreur technique"
			}
		},
		"minute": {
			"units": {
				"hour": "h",
				"minute": "min",
				"second": "sec"
			}
		}
	},
	"inputs": {
		"availabilitytype": {
			"types": {
				"chat": "Chat"
			}
		},
		"category": {
			"categories": {
				"accounting": "Comptabilité & Gestion",
				"achitecture": "Architecture & Design",
				"art": "Arts, Musique, Culture",
				"body_care": "Soin du corps & Remise en forme",
				"business": "Business & Finances",
				"coaching": "Coaching & Compétences",
				"consumer_goods": "Biens de consommation",
				"digital_economy": "Economie digitale",
				"divination": "Voyance",
				"economy": "Economie",
				"education": "Education & Emploi",
				"energy": "Energie & Environnement",
				"estate": "Immobilier",
				"fashion": "Modes & Tendances",
				"gardening": "Maison & Jardinage",
				"graphism": "Graphisme & Design",
				"handworker": "Artisanat",
				"hobbies": "Hobbies & Loisirs",
				"industry": "Industrie",
				"innovation": "Innovation, R&D",
				"insurance": "Assurance",
				"internet": "Internet",
				"low": "Droit",
				"managment": "Management",
				"marketing": "Marketing & Ventes",
				"media": "Media",
				"medical": "Médical",
				"personal_development": "Développement personnel",
				"resource_managment": "Organisation & RH",
				"restoration": "Restauration",
				"sciences": "Sciences & Technologies",
				"sport": "Sports",
				"strategy": "Stratégie & Transformation",
				"sustainability": "Développement durable",
				"tourism": "Voyage & Tourisme",
				"training": "Formation",
				"web_development": "Web Développement",
				"web_marketing": "Web Marketing",
				"wellness": "Bien-Etre & Santé"
			}
		},
		"date": {
			"cancel": "Annuler",
			"clear": "Supprimer"
		},
		"delay": {
			"ranges": {
				"hours": "Heure(s)",
				"days": "Jour(s)",
				"weeks": "Semaine(s)"
			}
		},
		"income": {
			"income": {
				"1": "inférieur à 18K€",
				"2": "supérieur 18K€ et inférieur 30K€",
				"3": "supérieur 30K€ et inférieur 50K€",
				"4": "supérieur 50K€ et inférieur 80K€",
				"5": "supérieur 80K€ et inférieur 120K€",
				"6": "supérieur à 120K€"
			}
		},
		"minute": {
			"minutes": "minute(s)"
		},
		"occupation": {
			"farmer": "Agriculteurs exploitants",
			"merchant": "Artisans, commerçants et chefs d’entreprise",
			"upper_manager": "Cadres et professions intellectuelles supérieures",
			"intermediate_profession": "Professions intermédiaires",
			"employees": "Employés",
			"worker": "Ouvriers",
			"retirees": "Retraités",
			"no_occupation": "Autres personnes sans activité professionnelle"
		},
		"offertype": {
			"types": {
				"promotion": "Offre promotionnelle",
				"private": "Offre privée",
				"public": "Offre publique"
			}
		},
		"phone": {
			"error": "Ce numéro n'est pas valide"
		},
		"portfolio": {
			"labels": {
				"picture": "Photo",
				"video": "Vidéo"
			},
			"video": {
				"text": "Vous pouvez ajouter une vidéo de Youtube ou Vimeo",
				"url": "Vidéo url",
				"button": "Ajouter"
			}
		},
		"services": {
			"services": {
				"tourism": "Téléconsultation",
				"remote": "Service à distance",
				"audit": "Audit, Conseil et Études",
				"course": "Cours, Formation, Orientation",
				"design": "Graphisme et Design",
				"development": "Développement Web",
				"documents": "Réalisation de documents",
				"other_service": "Consultation en cabinet",
				"receipe": "Recettes et régimes",
				"marketing": "Webmarketing",
				"advertising": "Publicité en ligne ",
				"other": "Autre"
			}
		},
		"servicetype": {
			"services": {
				"prepaid_minute": "Consultation par téléphone",
				"availability": "Consultation par chat",
				"mail": "Consultation par écrit",
				"service": "Services divers",
				"product": "Produit digital"
			}
		},
		"timezone": {
			"timezones": {
				"American Samoa": "(GMT-11:00) American Samoa",
				"International Date Line West": "(GMT-11:00) International Date Line West",
				"Midway Island": "(GMT-11:00) Midway Island",
				"Hawaii": "(GMT-10:00) Hawaii",
				"Alaska": "(GMT-09:00) Alaska",
				"Pacific Time (US & Canada)": "(GMT-08:00) Pacific Time (US & Canada)",
				"Tijuana": "(GMT-08:00) Tijuana",
				"Arizona": "(GMT-07:00) Arizona",
				"Chihuahua": "(GMT-07:00) Chihuahua",
				"Mazatlan": "(GMT-07:00) Mazatlan",
				"Mountain Time (US & Canada)": "(GMT-07:00) Mountain Time (US & Canada)",
				"Central America": "(GMT-06:00) Central America",
				"Central Time (US & Canada)": "(GMT-06:00) Central Time (US & Canada)",
				"Guadalajara": "(GMT-06:00) Guadalajara",
				"Mexico City": "(GMT-06:00) Mexico City",
				"Monterrey": "(GMT-06:00) Monterrey",
				"Saskatchewan": "(GMT-06:00) Saskatchewan",
				"Bogota": "(GMT-05:00) Bogota",
				"Eastern Time (US & Canada)": "(GMT-05:00) Eastern Time (US & Canada)",
				"Indiana (East)": "(GMT-05:00) Indiana (East)",
				"Lima": "(GMT-05:00) Lima",
				"Quito": "(GMT-05:00) Quito",
				"Atlantic Time (Canada)": "(GMT-04:00) Atlantic Time (Canada)",
				"Caracas": "(GMT-04:00) Caracas",
				"Georgetown": "(GMT-04:00) Georgetown",
				"La Paz": "(GMT-04:00) La Paz",
				"Santiago": "(GMT-04:00) Santiago",
				"Newfoundland": "(GMT-03:0-30) Newfoundland",
				"Brasilia": "(GMT-03:00) Brasilia",
				"Buenos Aires": "(GMT-03:00) Buenos Aires",
				"Greenland": "(GMT-03:00) Greenland",
				"Montevideo": "(GMT-03:00) Montevideo",
				"Mid-Atlantic": "(GMT-02:00) Mid-Atlantic",
				"Azores": "(GMT-01:00) Azores",
				"Cape Verde Is.": "(GMT-01:00) Cape Verde Is.",
				"Casablanca": "(GMT+00:00) Casablanca",
				"Dublin": "(GMT+00:00) Dublin",
				"Edinburgh": "(GMT+00:00) Edinburgh",
				"Lisbon": "(GMT+00:00) Lisbon",
				"London": "(GMT+00:00) London",
				"Monrovia": "(GMT+00:00) Monrovia",
				"UTC": "(GMT+00:00) UTC",
				"Amsterdam": "(GMT+01:00) Amsterdam",
				"Belgrade": "(GMT+01:00) Belgrade",
				"Berlin": "(GMT+01:00) Berlin",
				"Bern": "(GMT+01:00) Bern",
				"Bratislava": "(GMT+01:00) Bratislava",
				"Brussels": "(GMT+01:00) Brussels",
				"Budapest": "(GMT+01:00) Budapest",
				"Copenhagen": "(GMT+01:00) Copenhagen",
				"Ljubljana": "(GMT+01:00) Ljubljana",
				"Madrid": "(GMT+01:00) Madrid",
				"Paris": "(GMT+01:00) Paris",
				"Prague": "(GMT+01:00) Prague",
				"Rome": "(GMT+01:00) Rome",
				"Sarajevo": "(GMT+01:00) Sarajevo",
				"Skopje": "(GMT+01:00) Skopje",
				"Stockholm": "(GMT+01:00) Stockholm",
				"Vienna": "(GMT+01:00) Vienna",
				"Warsaw": "(GMT+01:00) Warsaw",
				"West Central Africa": "(GMT+01:00) West Central Africa",
				"Zagreb": "(GMT+01:00) Zagreb",
				"Athens": "(GMT+02:00) Athens",
				"Bucharest": "(GMT+02:00) Bucharest",
				"Cairo": "(GMT+02:00) Cairo",
				"Harare": "(GMT+02:00) Harare",
				"Helsinki": "(GMT+02:00) Helsinki",
				"Istanbul": "(GMT+02:00) Istanbul",
				"Jerusalem": "(GMT+02:00) Jerusalem",
				"Kyiv": "(GMT+02:00) Kyiv",
				"Pretoria": "(GMT+02:00) Pretoria",
				"Riga": "(GMT+02:00) Riga",
				"Sofia": "(GMT+02:00) Sofia",
				"Tallinn": "(GMT+02:00) Tallinn",
				"Vilnius": "(GMT+02:00) Vilnius",
				"Baghdad": "(GMT+03:00) Baghdad",
				"Kuwait": "(GMT+03:00) Kuwait",
				"Minsk": "(GMT+03:00) Minsk",
				"Moscow": "(GMT+03:00) Moscow",
				"Nairobi": "(GMT+03:00) Nairobi",
				"Riyadh": "(GMT+03:00) Riyadh",
				"St. Petersburg": "(GMT+03:00) St. Petersburg",
				"Volgograd": "(GMT+03:00) Volgograd",
				"Tehran": "(GMT+03:30) Tehran",
				"Abu Dhabi": "(GMT+04:00) Abu Dhabi",
				"Baku": "(GMT+04:00) Baku",
				"Muscat": "(GMT+04:00) Muscat",
				"Tbilisi": "(GMT+04:00) Tbilisi",
				"Yerevan": "(GMT+04:00) Yerevan",
				"Kabul": "(GMT+04:30) Kabul",
				"Ekaterinburg": "(GMT+05:00) Ekaterinburg",
				"Islamabad": "(GMT+05:00) Islamabad",
				"Karachi": "(GMT+05:00) Karachi",
				"Tashkent": "(GMT+05:00) Tashkent",
				"Chennai": "(GMT+05:30) Chennai",
				"Kolkata": "(GMT+05:30) Kolkata",
				"Mumbai": "(GMT+05:30) Mumbai",
				"New Delhi": "(GMT+05:30) New Delhi",
				"Sri Jayawardenepura": "(GMT+05:30) Sri Jayawardenepura",
				"Kathmandu": "(GMT+05:45) Kathmandu",
				"Almaty": "(GMT+06:00) Almaty",
				"Astana": "(GMT+06:00) Astana",
				"Dhaka": "(GMT+06:00) Dhaka",
				"Urumqi": "(GMT+06:00) Urumqi",
				"Rangoon": "(GMT+06:30) Rangoon",
				"Bangkok": "(GMT+07:00) Bangkok",
				"Hanoi": "(GMT+07:00) Hanoi",
				"Jakarta": "(GMT+07:00) Jakarta",
				"Krasnoyarsk": "(GMT+07:00) Krasnoyarsk",
				"Novosibirsk": "(GMT+07:00) Novosibirsk",
				"Beijing": "(GMT+08:00) Beijing",
				"Chongqing": "(GMT+08:00) Chongqing",
				"Hong Kong": "(GMT+08:00) Hong Kong",
				"Irkutsk": "(GMT+08:00) Irkutsk",
				"Kuala Lumpur": "(GMT+08:00) Kuala Lumpur",
				"Perth": "(GMT+08:00) Perth",
				"Singapore": "(GMT+08:00) Singapore",
				"Taipei": "(GMT+08:00) Taipei",
				"Ulaanbaatar": "(GMT+08:00) Ulaanbaatar",
				"Osaka": "(GMT+09:00) Osaka",
				"Sapporo": "(GMT+09:00) Sapporo",
				"Seoul": "(GMT+09:00) Seoul",
				"Tokyo": "(GMT+09:00) Tokyo",
				"Yakutsk": "(GMT+09:00) Yakutsk",
				"Adelaide": "(GMT+09:30) Adelaide",
				"Darwin": "(GMT+09:30) Darwin",
				"Brisbane": "(GMT+10:00) Brisbane",
				"Canberra": "(GMT+10:00) Canberra",
				"Guam": "(GMT+10:00) Guam",
				"Hobart": "(GMT+10:00) Hobart",
				"Melbourne": "(GMT+10:00) Melbourne",
				"Port Moresby": "(GMT+10:00) Port Moresby",
				"Sydney": "(GMT+10:00) Sydney",
				"Vladivostok": "(GMT+10:00) Vladivostok",
				"Magadan": "(GMT+11:00) Magadan",
				"New Caledonia": "(GMT+11:00) New Caledonia",
				"Solomon Is.": "(GMT+11:00) Solomon Is.",
				"Auckland": "(GMT+12:00) Auckland",
				"Fiji": "(GMT+12:00) Fiji",
				"Kamchatka": "(GMT+12:00) Kamchatka",
				"Marshall Is.": "(GMT+12:00) Marshall Is.",
				"Wellington": "(GMT+12:00) Wellington",
				"Chatham Is.": "(GMT+12:45) Chatham Is.",
				"Nuku'alofa": "(GMT+13:00) Nuku'alofa",
				"Samoa": "(GMT+13:00) Samoa",
				"Tokelau Is.": "(GMT+13:00) Tokelau Is."
			}
		},
		"weekday": {
			"wday": [
				"Dimanche",
				"Lundi",
				"Mardi",
				"Mercredi",
				"Jeudi",
				"Vendredi",
				"Samedi"
			]
		}
	},
	"messenger": {
		"more": "Charger plus",
		"actions": {
			"createappointment": {
				"next": "Suivant",
				"select": "Partager",
				"submit": "Partager",
				"title": {
					"default": "Proposer un rendez-vous",
					"day": "Jour",
					"hour": "Heure",
					"message": "Message"
				},
				"labels": {
					"day": "Jour du rendez-vous",
					"hour": "Heure du rendez-vous",
					"message": "Message"
				},
				"message": "Cliquez sur le lien ci-dessous pour accepter un rendez-vous avec {nickname}"
			},
			"fileupload": {
				"submit": "Envoyer",
				"title": "Envoyer un fichier",
				"labels": {
					"file": "Choisir mon fichier"
				}
			},
			"shareoffer": {
				"next": "Suivant",
				"select": "Partager",
				"submit": "Partager",
				"title": {
					"default": "Partage d'offre",
					"kind": "Type d'offre",
					"offer": "Offre",
					"message": "Message"
				},
				"labels": {
					"scope": "Type d'offre",
					"message": "Message"
				},
				"scopes": {
					"public": "Publiques",
					"promotion": "Promotions",
					"private": "Privées"
				}
			},
			"sharepage": {
				"next": "Suivant",
				"select": "Partager",
				"submit": "Partager",
				"title": {
					"default": "Partage d'une page",
					"kind": "Catégorie",
					"page": "Page",
					"message": "Message"
				},
				"labels": {
					"scope": "Catégorie",
					"message": "Message"
				}
			}
		},
		"previews": {
			"offer": {
				"action": "Voir"
			}
		},
		"conversations": {
			"title": "Envoyer un Message"
		},
		"menu": {
			"actions": {
				"upload": "Envoyer un fichier",
				"share": "Partager une offre",
				"page": "Partager une page",
				"appointment": "Envoyer un rendez-vous"
			}
		}
	},
	"purchase": {
		"availability": {
			"start": "Démarrer le chat",
			"stop": "Stop"
		},
		"appointment": {
			"accept": "Accepter le rendez-vous",
			"refund": "Annuler le rendez-vous"
		},
		"call": {
			"informations": "Informations sur l'appel",
			"none": "-",
			"starts": "Date d'appel",
			"pricePerMin": "Prix estimé par minute",
			"timeLimit": "Durée maximum d'appel",
			"duration": "Durée d'appel",
			"error": "Erreur survenue",
			"statusLabel": "Status de l'appel",
			"hangup": "Raccrocher",
			"hangupText": "Pour utiliser ce bouton assurez-vous que votre téléphone soit bien raccroché et que votre statut sur la plateforme soit toujours \"En consultation\"",
			"debug": "Détails",
			"callee": "Utilisateur",
			"caller": "Expert",
			"download": "Télécharger l'appel",
			"downloadStart": "Votre téléchargement va commencer, cela peut prendre quelques secondes avant que le téléchargement commence",
			"status": {
				"queued": "En cours d'appel",
				"ringing": "En cours d'appel",
				"no-answer": "Aucune réponse",
				"busy": "Occupé",
				"in-progress": "En cours",
				"completed": "Terminé",
				"failed": "Erreur",
				"canceled": "Annulé"
			}
		},
		"callplayer": {
			"title": "Écouter l'appel",
			"error": "Aucuns fichiers audio associés"
		},
		"mail": {
			"request": "Question :",
			"response": "Réponse :",
			"responseForm": "Votre réponse",
			"accept": "Accepter"
		},
		"messageform": {
			"save": "Répondre et terminer",
			"labels": {
				"title": "Titre",
				"content": "Réponse"
			}
		},
		"refund": {
			"refund": "Annuler et rembourser",
			"refundText": "En annulant cette prestation le client sera remboursé de son achat",
			"reason": "Describe a reason"
		},
		"service": {
			"request": "Demande :",
			"response": "Réponse :",
			"responseForm": "Votre réponse",
			"accept": "Accepter"
		},
		"table": {
			"noDataText": {
				"default": "Pas encore d'achats",
				"mail": "Pas encore d'emails",
				"service": "Pas encore de services",
				"phone": "Pas encore d'appels",
				"prepaid_minute": "Pas encore de forfaits",
				"availability": "Pas encore de chats",
				"product": "Pas encore de produit"
			},
			"noResultsText": {
				"default": "Aucuns achats",
				"mail": "Aucuns emails",
				"service": "Aucuns services",
				"phone": "Aucuns appels",
				"prepaid_minute": "Aucuns forfaits",
				"availability": "Aucuns chats",
				"product": "Auncuns produits"
			},
			"rowsPerPageText": {
				"default": "Achats par page",
				"mail": "Emails par page",
				"service": "Services par page",
				"phone": "Appels par page",
				"prepaid_minute": "Forfaits par page",
				"availability": "Chats par page",
				"product": "Produits par page"
			},
			"scopes": {
				"all": "",
				"payed": "payés",
				"refunded": "remboursés",
				"pending": "en attente",
				"current": "en cours",
				"finished": "terminés",
				"with_cash_received": "payés",
				"finished_with_cash_received_or_failed": "payés ou échoués"
			},
			"header": {
				"id": "Id",
				"offer": "Offre",
				"user": "Client",
				"expert": "Expert",
				"payedAt": "Date de paiement",
				"price": "Prix",
				"fees": "Frais",
				"total": "Total"
			}
		},
		"title": {
			"appointment": "Rendez-vous",
			"call": "Appel de",
			"perMin": "/min",
			"callStatus": {
				"in-progress": "Appel en cours",
				"no-answer": "Appel non répondu",
				"busy": "Appel avec correspondant occupé",
				"error": "Appel avec erreur : {error}",
				"failed": "Appel avec erreur : {error}",
				"canceled": "Appel annulé"
			}
		}
	},
	"service": {
		"actions": {
			"copy": "Lien copié",
			"edit": "Mettre à jour"
		},
		"form": {
			"save": "Sauvegarder",
			"delete": "Supprimer",
			"confirmDeletion": "Êtes-vous sûr ?",
			"errors": {
				"minutes": "Le tarif d'une minute doit être d'au moins {price} centimes par minutes"
			},
			"labels": {
				"experts": "Experts béneficiant de cette offre",
				"offerType": "Type d'offre",
				"serviceType": "Type d'offre",
				"title": "Titre de votre offre",
				"price": "Prix de l'offre",
				"service--serviceType": "Type de service",
				"service--responseDelay": "Délais de réponse",
				"prepaidMinute--minutes": "Nombre de minutes",
				"product--message": "Message après l'achat de votre produit",
				"mail--responseDelay": "Délais de réponse",
				"mail--wordCount": "Nombre de mots minimum",
				"availability--duration": "Durée",
				"availability--availabilityType": "Type de disponibilité",
				"description": "Description de l'offre",
				"portfolio": "Portfolio",
				"subtitle": "Sous titre de l'offre (utile pour le partage)",
				"picture": "Image de partage",
				"shortDescription": "Courte description de l'offre",
				"keywords": "Mot clés (séparés par une virgule)",
				"expire": "Date d'expiration",
				"maxUserPurchase": "Nombre d'achats maximum par utilisateur (0 = illimité)"
			}
		},
		"meta": {
			"prepaid_minute": "Forfait",
			"mail": "Mail",
			"service": "Service",
			"phone": "Appel",
			"product": "Produit",
			"availability": "Chat",
			"services": {
				"advertising": "Publicité en ligne ",
				"audit": "Audit, Conseil et Études",
				"course": "Cours, Formation, Orientation",
				"design": "Graphisme et Design",
				"development": "Développement Web",
				"documents": "Réalisation de documents",
				"marketing": "Webmarketing",
				"other": "Autre",
				"other_service": "Consultation en cabinet",
				"receipe": "Recettes et régimes",
				"remote": "Service à distance",
				"tourism": "Téléconsultation"
			},
			"options": {
				"word_count": "{value} mot(s)",
				"hours": "{value} heure(s)",
				"minutes": "{value} minute(s)",
				"days": "{value} jour(s)",
				"service_type": "{value}",
				"duration": "{value} minute(s)",
				"availability_type": "{value}"
			}
		}
	},
	"user": {
		"import": {
			"labels": {
				"sendEmail": "Notifier l'utilisateur"
			},
			"save": "Importer"
		},
		"form": {
			"save": "Créer",
			"labels": {
				"email": "Email",
				"password": "Mot de passe",
				"passwordConfirmation": "Confirmation de mot de passe",
				"sendEmail": "Notifier l'utilisateur"
			}
		},
		"header": {
			"messenger": "Envoyer un message",
			"more": "Plus",
			"lock": "Bloquer",
			"unlock": "Débloquer",
			"risk": "Activer surveillance",
			"unrisk": "Désactiver surveillance",
			"minute_gift": "Offrir des minutes",
			"lockreason": "Raison du blockage",
			"unlockreason": "Raison du déblockage",
			"riskreason": "Raison de ce changement",
			"unriskreason": "Raison de ce changement"
		},
		"profile": {
			"save": "Sauvegarder mes notes",
			"none": "-",
			"note": "Notes sur l'utilisateur",
			"subtitles": {
				"personal": "Informations personnelles",
				"contact": "Information de contact",
				"other": "Autres informations",
				"activity": "Activité"
			},
			"item": {
				"nickname": "Pseudo",
				"firstName": "Prénom",
				"lastName": "Nom",
				"email": "Email",
				"phone": "Téléphone",
				"createdAt": "Compte créé",
				"lastConnection": "Dernière connection",
				"lockedAt": "Compte bloqué",
				"minutes": "Minutes restantes",
				"riskyAt": "Surveillance activée"
			}
		},
		"purchases": {
			"title": "Prestations terminées"
		},
		"search": {
			"submit": "Rechercher",
			"clear": "Supprimer",
			"labels": {
				"first_name_cont": "Prénom",
				"last_name_cont": "Nom",
				"nickname_cont": "Pseudo",
				"email_cont": "Email",
				"phone_cont": "Numéro de téléphone",
				"locked": "Uniquement utilisateurs bloqués",
				"risky_at": "Uniquement utilisateurs risqués"
			}
		},
		"statistics": {
			"rates": "Avis donnés",
			"ratesPending": "Avis en attente",
			"ratesAverage": "Moyenne d'avis",
			"purchasesTotal": "Achats",
			"purchasesAmount": "Total dépensé",
			"purchasesAverage": "Prix d'achat moyen",
			"purchaseHistory": "Historique d'achat"
		},
		"table": {
			"title": "Utilisateurs",
			"noDataText": "Pas encore d'utilisateurs",
			"noResultsText": "Aucuns utilisateurs",
			"rowsPerPageText": "Utilisateurs par page",
			"sendToAll": "Message pour tous",
			"send": "Envoyer un message",
			"selected": "utilisateur séléctionné | utilisateurs séléctionnés",
			"header": {
				"nickname": "Pseudo",
				"last_name": "Nom",
				"first_name": "Prénom",
				"email": "Email",
				"payed_purchases_sum": "Dépensé",
				"phone_seconds_available": "Minutes",
				"created_at": "Inscrit le",
				"current_sign_in_at": "Dernière connection"
			}
		}
	},
	"activities": {
		"type": {
			"LOCK": "{nickname} bloqué",
			"UNLOCK": "{nickname} débloqué",
			"RISKY": "{nickname} surveillé",
			"UNRISKY": "{nickname} non surveillé",
			"ALERT": "Alerte pour {nickname}",
			"MINUTES": "{nickname} a reçu {minutes} minutes",
			"REFUND": "Refund pour {nickname}"
		},
		"reason": {
			"ALERT": "{amount}{currency} en moins de {timeframe} jours"
		}
	},
	"applicationmenu": {
		"menu": {
			"dashboard": {
				"default": "Tableaux de bord",
				"todo": "Mes tâches",
				"revenues": "Revenus de la plateforme",
				"traffic": "Trafic de la plateforme",
				"availabilities": "Disponibilités",
				"gains": "Mes gains",
				"statistics": "Statistiques",
				"accounts": "Comptes"
			},
			"customers": "Clients",
			"messenger": "Envoyer un message",
			"purchases": "Ventes",
			"services": {
				"create": "Nouvelle offre",
				"default": "Offres",
				"public": "Publiques",
				"promotions": "Promotions",
				"private": "Privées"
			},
			"pages": {
				"default": "Contenus"
			},
			"feedbacks": {
				"default": "Avis",
				"pending": "En attente",
				"accepted": "Acceptés",
				"rejected": "Rejetés"
			},
			"settings": {
				"default": "Paramètres",
				"platform": "Profil",
				"account": "Informations",
				"schedule": "Horaires",
				"transfers": "Virements",
				"bank": "Bank",
				"subscription": "Abonnement",
				"team": "Équipe",
				"customization": "Personnalisation",
				"links": "Smart links"
			}
		}
	},
	"applicationtoolbar": {
		"edit": "Mon profil",
		"logout": "Se déconnecter",
		"pause": "Me mettre en pause",
		"finishPause": "Terminer ma pause",
		"resolveSubscription": "Régler mon abonnement"
	},
	"calltimeline": {
		"state": {
			"queued": "En attente",
			"ringing": "Sonnerie",
			"no-answer": "Pas de réponse",
			"busy": "Occupé",
			"completed": "Terminé",
			"failed": "Échoué",
			"in-progress": "Appel en cours"
		}
	},
	"cardform": {
		"title": "Ajouter une carte",
		"save": "Ajouter ma carte",
		"labels": {
			"number": "Numéro de carte",
			"month": "Mois",
			"year": "Année",
			"cvx": "Code de sécurité"
		}
	},
	"dateintervalpicker": {
		"dates": [
			"Du",
			"au"
		]
	},
	"feedbackactions": {
		"update": "Modifier",
		"comment": "Commenter",
		"accept": "Publier",
		"reject": "Rejeter",
		"cancel": "Annuler",
		"save": "Sauvegarder",
		"saveAndPublish": "Sauvegarder et publier"
	},
	"feedbackcontent": {
		"by": "Par :",
		"date": "Le :"
	},
	"feedbackform": {
		"labels": {
			"note": "Note",
			"content": "Contenu",
			"response": "Réponse"
		}
	},
	"headerform": {
		"title": "Ajouter un header",
		"or": "ou",
		"save": "Ajouter",
		"labels": {
			"picture": "Image de fond",
			"video": "Video de fond",
			"pictureForVideo": "Image pour la video",
			"title": "Titre",
			"subtitle": "Sous titre",
			"actionTitle": "Titre du bouton",
			"actionHref": "Lien du bouton"
		}
	},
	"headersform": {
		"title": "Headers de mon site",
		"addHeader": "Ajouter un header"
	},
	"invitationform": {
		"title": "Inviter un nouvel expert",
		"text": "Entrez ici l'adresse email de votre nouvel expert et celui-ci sera prévenu par email par lequel il pourra se connecter et rejoindre votre équipe",
		"submit": "Inviter",
		"labels": {
			"email": "Email",
			"password": "Mot de passe"
		},
		"hints": {
			"password": "Laisser vide pour envoyer une invitation"
		}
	},
	"linkcreation": {
		"title": "Titre",
		"url": "Url",
		"save": "Sauvegarder"
	},
	"minutegiftform": {
		"title": "Offrir des minutes d'appel",
		"card": "Prélever ma carte",
		"submit": "Offrir {minutes} minute(s) pour {price} EUR",
		"offer": "Offrir",
		"text": "Vous êtes sur le point d'offrir {minutes} minute(s) à {price} EUR/min",
		"labels": {
			"minutes": "Nombre de minutes",
			"reason": "Raison"
		}
	},
	"outcometable": {
		"header": {
			"id": "Id",
			"date": "Date de paiement",
			"status": "Status",
			"amount": "Prix"
		}
	},
	"refundedtag": {
		"refunded": "Annulé"
	},
	"sharecard": {
		"networks": {
			"facebook": "Facebook",
			"twitter": "Twitter",
			"googleplus": "Google +",
			"linkedin": "LinkedIn"
		}
	},
	"smartlink": {
		"title": "Titre",
		"url": "URL",
		"icon": "Icone",
		"add": "Ajouter",
		"save": "Sauvegarder"
	},
	"transfer": {
		"title": "Virement",
		"submit": "Virer cet argent",
		"missingText": "Vous n'avez pas encore renseigner vos informations bancaires",
		"addBank": "Mettre à jour",
		"text": "Virer mon argent sur mon compte {iban}",
		"hints": {
			"amount": "Maximum 2500€ par virement"
		},
		"labels": {
			"amount": "Montant du virement",
			"reference": "Référence"
		}
	},
	"transfertable": {
		"noDataText": "Pas encore de virements",
		"noResultsText": "Aucuns virements",
		"rowsPerPageText": "Virements par page",
		"header": {
			"date": "Date",
			"status": "État",
			"amount": "Prix"
		},
		"status": {
			"CREATED": "En attente",
			"FAILED": "Échoué",
			"SUCCEEDED": "Terminé"
		}
	},
	"usermenu": {
		"actions": "Actions",
		"sendToAll": "Message pour tous",
		"send": "Envoyer un message",
		"addUser": "Ajouter un utilisateur",
		"export": "Exporter les utilisateurs",
		"exportStarted": "Votre export est en cours, vous recevrez un email dès que l'export sera terminé",
		"import": "Importer des utilisateurs"
	},
	"wallet": {
		"title": "Argent disponible",
		"transfer": "Transférer"
	},
	"pages": {
		"accounting": {
			"title": "Comptes"
		},
		"account": {
			"tabs": {
				"profile": "Profil",
				"informations": "Numéro de Téléphone",
				"schedule": "Agenda",
				"bank": "Banque"
			}
		},
		"customization": {
			"style": "Configurer le style",
			"links": "Liens footer",
			"save": "Sauvegarder",
			"addLink": "Ajouter un lien",
			"labels": {
				"removePic": "Supprimer",
				"logo": "Logo de votre site",
				"favicon": "Favicon de votre site",
				"color": {
					"primary": "Couleur principale",
					"secondary": "Couleur secondaire"
				},
				"feedbacks": "Afficher les avis clients"
			}
		},
		"dashboard": {
			"title": {
				"default": "Mes tâches",
				"phone": "Appels",
				"mail": "Mails",
				"service": "Services",
				"availability": "Chat",
				"pending": "En attente",
				"current": "En cours"
			}
		},
		"expert": {
			"tabs": {
				"profile": "Profil",
				"schedule": "Horaires",
				"purchases": "Prestations",
				"connection": "Connexion"
			}
		},
		"expertgains": {
			"title": "Gains"
		},
		"feedbacks": {
			"empty": "Aucuns avis",
			"pending": "en attente",
			"accepted": "acceptés",
			"rejected": "rejetés"
		},
		"forgotpassword": {
			"title": "Mot de passe oublié",
			"reset": "Envoyer les instructions",
			"login": "Se connecter",
			"success": "Un mail vous a été envoyé",
			"labels": {
				"email": "Email",
				"platformName": "Url de votre plateforme"
			}
		},
		"invitation": {
			"title": "Accepter votre invitation",
			"submit": "Accepter",
			"terms": "Conditions d'utilisation",
			"privacy": "Politique de confidentialité",
			"labels": {
				"password": "Mot de passe",
				"confirmation": "Confirmation de mot de passe",
				"terms": "Accepter les CGU et la Politique de confidentialité"
			}
		},
		"login": {
			"title": "Se connecter",
			"login": "Se connecter",
			"forgotPassword": "Mot de passe oublié",
			"labels": {
				"email": "Email",
				"password": "Mot de passe",
				"platformName": "Url"
			}
		},
		"messengerwelcome": {
			"select": "Veuillez sélectionner une conversation"
		},
		"notfound": {
			"title": "404",
			"text": "Page inexistante"
		},
		"platformrevenues": {
			"title": "Chiffre d'affaire"
		},
		"platformtraffic": {
			"title": "Informations du site"
		},
		"purchases": {
			"title": "Achats"
		},
		"resetpassword": {
			"title": "Changer mon mot de passer",
			"submit": "Changer mon mot de passe",
			"login": "Se connecter",
			"passwordTokenError": "Votre code n'est pas bon, veuillez renvoyer un nouvel email",
			"forgot": "Renvoyer l'email",
			"labels": {
				"password": "Nouveau mot de passe",
				"confirmation": "Confirmation du mot de passe"
			}
		},
		"servicecreation": {
			"title": "Création d'une offre"
		},
		"serviceedition": {
			"title": "Edition - {title}"
		},
		"setup": {
			"title": "Mes informations",
			"submit": "Sauvegarde",
			"labels": {
				"category": "Catégorie",
				"firstName": "Prénom",
				"lastName": "Nom",
				"birthday": "Date de naissance",
				"phone": "Numéro de téléphone"
			}
		},
		"statistics": {
			"title": "Statistiques",
			"expert": "Expert",
			"sum": "Total de minutes",
			"total": "Total d'appels",
			"average": "Temps moyen",
			"minMax": "Temps min / max",
			"price_minute": "Prix par minute",
			"price_average": "Prix d'achat moyen",
			"collector": "Argent du collector",
			"call": "Appels",
			"email": "Emails",
			"chat": "Chats",
			"service": "Services",
			"product": "Produits",
			"gains": "Gains"
		},
		"subscription": {
			"title": "Mon abonnement",
			"current": "Plan actuel",
			"next": "Prochain paiement",
			"card": "Ma carte de prélèvement",
			"noCard": "Vous n'avez pas de cartes pour votre prélèvement",
			"cardDetails": "Vous utilisez la carte {alias} qui expire le {month}/{year}",
			"updateCard": "Mettre à jour ma carte"
		},
		"subscriptionpayment": {
			"pay": "Payer mon abonnement",
			"inProgress": "Paiement en cours"
		},
		"team": {
			"title": "Mon équipe",
			"noDataText": "Pas encore d'experts",
			"noResultsText": "Aucuns experts trouvé",
			"header": {
				"nickname": "Pseudo",
				"email": "Email",
				"role": "Status",
				"actions": "Classement"
			},
			"roles": {
				"active": "Actif",
				"inactive": "Inactif",
				"restricted": "Restreint"
			}
		},
		"teamavailabilities": {
			"title": "Disponibilité de l'équipe",
			"today": "Total aujourd'hui",
			"average": "Moyenne par expert",
			"max": "Maximum par expert",
			"perWeek": "Semaine",
			"perDay": "Jour",
			"days": [
				"Dimanche",
				"Lundi",
				"Mardi",
				"Mercredi",
				"Jeudi",
				"Vendredi",
				"Samedi"
			]
		},
		"transfers": {
			"title": "Mes transferts"
		},
		"user": {
			"tabs": {
				"profile": "Profil",
				"statistics": "Statistiques",
				"purchases": "Prestations"
			}
		},
		"users": {
			"title": "Utilisateurs",
			"selected": "utilisateur séléctionné | utilisateurs séléctionnés",
			"search": "Rechercher"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/i18n/fr.json
// module id = 744
// module chunks = 32